import detail from './pages/detail';

detail();
